import request from '@/api/request'

/**
 * 分页查询孵化组表
 */
export const getListPage = params => {
  return request({
    url: 'admin/analyse/adm/baseIncubate/getListPage',
    method: 'get',
    params
  })
}

/**
 * 添加 & 编辑孵化组表
 */
export const operateBaseIncubate = data => {
  let url = 'admin/analyse/adm/baseIncubate/addBaseIncubate'
  if (data.id) {
    url = 'admin/analyse/adm/baseIncubate/updateBaseIncubate'
  }
  return request({
    url,
    method: 'post',
    data
  })
}

/**
 * 解散孵化組
 */
export const dismissBaseIncubate = data => {
  return request({
    url: 'admin/analyse/adm/baseIncubate/updateStatus',
    method: 'post',
    data
  })
}

/**
 * 删除孵化组
 */
export const delBaseIncubate = data => {
  return request({
    url: 'admin/analyse/adm/baseIncubate/delBaseIncubate',
    method: 'post',
    data
  })
}

/**
 * 关联孵化组销售表
 */
export const addBaseIncubateSale = data => {
  return request({
    url: 'admin/analyse/adm/baseIncubateSale/addBaseIncubateSale',
    method: 'post',
    data
  })
}

/**
 * 分页查询销售关联表
 */
export const getGroupSale = params => {
  return request({
    url: 'admin/analyse/adm/baseIncubateSale/getListPage',
    method: 'get',
    params
  })
}

/**
 * 查询销售
 */
export const getSale = params => {
  return request({
    url: 'admin/analyse/adm/baseSale/getByIncubate',
    method: 'get',
    params
  })
}

/**
 * 导入销售
 */
export const importSale = (data) => {
  return request({
    url: 'analyse/adm/baseIncubateSale/importData',
    method: 'post',
    upload: true,
    data
  })
}
